module.exports = __webpack_public_path__ + "img/exel-mobile.29c497ba.svg";